import { LinearProgress, FormHelperText, Button, Dialog, TextField, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@material-ui/core'
import React, { useRef, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import "../styles/AdminApplicationsView.css"
import { myBucket } from '../services/UploadService'
import { ApiURL } from '../constants/ApiUrl'
function MemberApplicationsView() {
    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)
    const [Progress3, setProgress3] = useState(0)
    const [genderE, setgenderE] = useState('')
    const [blood_groupE, setblood_groupE] = useState('')
    const [collegeE, setcollegeE] = useState('')
    const [isTrue, setIsTrue] = useState(true)
    const [phoneE, setphoneE] = useState('')
    const [profileE, setProfileE] = useState("")
    const [signatureE, setsignatureE] = useState("")
    const [secEmailError, setsecEmailError] = useState("")
    const [RefMemN, setRefMemN] = useState("")
    const [secphoneE, setsecphoneE] = useState("")
    const [RefnameE, setRefnameE] = useState("")
    const [medError, setmedError] = useState("")
    const [RegE, setRegE] = useState('')
    const [memDoc, setmemDoc] = useState(false)
    const [emailError, setEmailError] = useState("")
    const [Editable, setEditable] = useState(false)
    const [approvemsg, setApprovemsg] = useState("")
    const [address, setAddress] = useState({})

    const [updatemsg, setUpdatemsg] = useState("")
    const [IsOpen7, setIsOpen7] = useState(false)

    const [isVerified, setIsVerified] = useState(true)
    const [TempCList, setTempCList] = useState([])
    const FData = useSelector(state => state.FormDataReducer)
    const [TempDetails, setTempDetails] = useState({})
    const [nmoLists, setNmoLists] = useState([])
    const [nmoPrant, setNmoPrant] = useState([])
    const [Tp, setTp] = useState(0)
    const [Tp1, setTp1] = useState(10)
    const [IsDegree, setIsDegree] = useState(false)
    // const history=useHistory();
    const LoginReducer = useSelector(state => state.LoginReducer)
    var loginRes;
    if (LoginReducer.user !== undefined) {
        loginRes = LoginReducer.user.role

    }
    const FormDetails = useSelector(state => state.AdminReducer.selectedApp);
    // const FData = useSelector(state => state.FormDataReducer)

    const result = JSON.parse(localStorage.getItem("result"))

    const gender = ["Male", "Female", "Other"]
    const bloodGroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]


    const [allDetials, setallDetials] = useState("")


    const [stateList, setStateList] = useState([])
    const [SName, setSName] = useState("")
    const [CName, setCName] = useState('');
    const [collagelist, setCollagelist] = useState([])

    const history = useHistory();
    const dispatch = useDispatch();

    if (result._id === undefined) {
        history.replace('/admin/applications');
       
    }


    var s = []
    const a = async () => {
        const result = await axios.get(`${ApiURL}/api/get_states`);
        result.data.forEach(element => {
            s.push(element.state_name)
        });
        setStateList(s)
    }
    const collegeChanged = (e) => {
        console.log(e, 'value of input')
        if (e == 'other') {
            setIsTrue(false)

        }
        setTempDetails({ ...TempDetails, ["college"]: e });
        setCName(e)
    }
    const handlefinalUpdate = () => {
        setIsOpen7(false)
        alert(approvemsg)
    }
    const stateChanged = async (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
        setSName(e.target.value)
        const result = await axios.post(`${ApiURL}/api/get_medical_college`, {            // addinng API for getting prant
            "state": e.target.value
        });
        const college_list = result.data
        college_list.forEach(element => {
            s.push(element)
        });

        setCollagelist(s)
    }
    const handleAddChange = (e) => {

        if (e.target.name === 'state') {
            FData.states.map((item) => {
                if (item.state === e.target.value) {
                    setTempCList(item.districts)
                }
                return true;
            })
        }
        setTempDetails({ ...TempDetails, address: { ...TempDetails.address, [e.target.name]: e.target.value } })
    }

    useEffect(() => {
        MemberData()

    }, [])


    var MemberData = async () => {
        var a = await axios.post(`${ApiURL}/api/get_mem_det`, {
            "id": result._id
        })
        console.log(result._id, "eeeeeeee")
        var add = {}
        if (a.data.code === 200) {
            setallDetials(a.data.success)
            // collegeChanged(a.data.success.college)
            // console.log(a.data.success.address)
            add = {
                line1: a.data.success.address.line1,
                city: a.data.success.address.city,
                line2: a.data.success.address.line2,
                pincode: a.data.success.address.pincode,
                state: a.data.success.address.state
            }
            if (a.data.success.appApproved === true) {
                setmemDoc(true)
            }
        }
        else if (a.data.code === 201) {
            setallDetials(a.data.success)
            console.log("details new data ", allDetials)
        }
        else {
            setUpdatemsg(a.data.msg)
            setIsVerified(false)

        }
        setAddress(add)
        console.log(address, "jkk")
    }
    const handleNoApp = () => {
        setIsOpen7(false)
    }

    var s = []
    const handleEdit = async () => {
        a()
        setProgress2(0)
        setProgress1(0)
        if (Editable) {
            setEditable(false);
        } else {
            const result = await axios.get(`${ApiURL}/api/get_states`);
            result.data.forEach(element => {
                s.push(element.state_name)
            });
            setNmoLists(s)
            if (FData.qual.length === 0) {
                const result = await axios.get(`${ApiURL}/constants/all`);
                const quali = result.data.qual.slice(0, 2)
                dispatch({ type: "SET_STATES", payload: result.data.state });
                if (allDetials.appType === 'student') {
                    dispatch({ type: "SET_QUAL", payload: quali });
                }
                else {
                    dispatch({ type: "SET_QUAL", payload: result.data.qual });
                }
            }
            collegeChanged(FormDetails.college)
            setTempDetails(allDetials)
            setEditable(true);
            FData.states.forEach((item) => {
                if (item.state === result.state) {
                    // setTempCList(item.districts)
                }
            })
        }
    }
    const handleUpdate = async () => {
        var results = JSON.parse(localStorage.getItem("result"))
        var all_update = {
            ...allDetials,
            ...TempDetails
        }
        const NumberRef = Number(all_update.ref_membership_no)
        console.log(all_update, "update")
        if (all_update.email === '') {
            setProfileE('')
            setEmailError("Email Id is Required")
            setphoneE('')
            setsignatureE('')
            alert("Email Id is Required")
            setRefMemN('')
        }
        else if (!all_update.email.includes('@') || !all_update.email.includes(all_update.email.toLowerCase())) {
            setEmailError("Inavlid Email")
            alert("Inavlid Email")

            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.phone == '') {
            setphoneE("Phone Number is Required")
            alert("Phone Number is Required")
            setEmailError("")
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.phone.length < 10) {
            setEmailError("")
            setphoneE("Invalid Phone Number")
            alert('Invalid Phone Number')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.profile_image === '') {
            setEmailError("")
            setProfileE("profile image is Required")
            alert("profile image is Required")
            setphoneE('')
            setsignatureE('')
            setRefMemN('')

        }
        else if (all_update.signature_image === '') {
            setEmailError("")
            setsignatureE("Signature image is required")
            alert("Signature image is required")
            setphoneE('')
            setProfileE('')
            setRefMemN('')
        }
        else if (all_update.cert_image === '') {
            setEmailError("")
            setmedError("Medical Licence  is Required")
            alert("Medical Licence  is Required")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.ref_membership_no == '') {
            setEmailError("")
            setRefMemN("Ref Membership Number is Required")
            alert("Ref Membership Number is Required")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
        }
        else if (all_update.ref_person_phone === '') {
            setsecphoneE("Ref Number is Required")
            alert("Ref Number is Required")
            setEmailError("")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.college === '') {
            setcollegeE("College Name is Required")
            alert("College Name is Required")
            setEmailError("")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')

        }
        else if (typeof (Number(all_update.regno)) !== 'number') {
            setRegE('Reg Number should be Number')
            alert('Reg Number should be Number')
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.ref_person_phone.length < 10) {
            setEmailError("")
            setsecphoneE("Invalid Contact Person Phone Number")
            alert("Invalid Contact Person Phone Number")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (typeof (NumberRef) !== 'number') {
            setRefMemN("Ref Membership Number should be a number")
            alert("Ref Membership Number should be a number")
            setEmailError("")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (all_update.ref_person === '') {
            setRefnameE("Name is Required")
            alert("Name is Required")
            setEmailError("")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')

        }
        else if (all_update.state_sec_email === '') {
            alert("Secretary Email Id is Required")
            setsecEmailError("Secretary Email Id is Required")
            setEmailError("")

            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else if (!all_update.state_sec_email.includes('@') || !all_update.state_sec_email.includes(all_update.state_sec_email.toLowerCase())) {
            setsecEmailError("Inavlid Email")
            alert("Inavlid Email")
            setEmailError("")

            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
        }
        else {
            setEmailError("")
            setphoneE('')
            setProfileE('')
            setsignatureE('')
            setRefMemN('')
            const result = await axios.post(`${ApiURL}/api/update_member`, {
                "update": all_update,
                "member_no": results.mem_no,
                "id": results._id
            });
            if (result.data.code === 200) {
                setIsOpen7(true)
                setApprovemsg(result.data.msg)
            }
            else {
                setUpdatemsg(result.data.msg)
                setIsVerified(false)
                // setDataUpdate(false)
            }

            setallDetials(all_update)
            setEditable(false);
            setTp(Tp + 1);
            setTp1(Tp1 + 1);
            dispatch({ type: "SELECTED_APPLICATION", payload: TempDetails });
            console.log(allDetials, "update")
        }


    }

    const handleChange = (e) => {
        // console.log(e.target.value,"degree")
        if (e.target.value === 'Other') {
            setIsDegree(true)
        }

        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });

    }
    const handelNmoState = async (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });

        const result = await axios.post(`${ApiURL}/api/get_prant`, {
            "state": e.target.value
        });
        setNmoPrant(result.data.prant_name)


    }
    const handelNmoPrant = async (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });

    }
    const uplodeSign = (e) => {
        const file = e.target.files;
        if (file.length === 0) {
            return;
        }
        let ext = file[0].name.split('.').pop().toLowerCase();
        let filename = "";
        var group = "";
        if (e.target.name === "signature_image") {
            if (ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only JPG, BMP, PNG files allowed");
                return;
            }
            group = allDetials.signature_image.split('/');
            filename = group.pop();
            filename = filename.split('.')[0];

        }
        console.log(allDetials.appType, "lllllll")
        if (allDetials.appType === 'old') {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appType}/${allDetials.mem_no}/signature_image.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress2(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appType}/${allDetials.mem_no}/signature_image.${ext}` });
                    }
                })
            setProgress2(0)

        }
        else {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appId}/${filename}.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress2(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appId}/${filename}.${ext}` });
                    }
                })
            setProgress2(0)
        }

    }

    const handleFileChange = (e) => {
        const file = e.target.files;
        if (file.length === 0) {
            return;
        }
        let ext = file[0].name.split('.').pop().toLowerCase();
        let filename = "";
        var group = "";
        if (e.target.name === "profile_image") {
            if (ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only JPG, BMP, PNG files allowed");
                return;
            }
            group = allDetials.profile_image.split('/');
            filename = group.pop();
            filename = filename.split('.')[0];

        }
        // console.log("File name",filename);
        if (allDetials.appType === 'old') {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appType}/${allDetials.mem_no}/profile_image.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress1(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appType}/${allDetials.mem_no}/profile_image.${ext}` });
                    }
                })
            setProgress1(0)

        }
        else {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appId}/${filename}.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress1(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appId}/${filename}.${ext}` });
                    }
                })
            setProgress1(0)
        }
    }
    const handleIdChange = (e) => {
        const file = e.target.files;
        let ext = file[0].name.split('.').pop().toLowerCase();
        let filename = "";
        var group = "";
        if (e.target.name === "cert_image") {
            if (ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png" && ext !== "pdf") {
                alert("Only JPG, BMP, PNG & PDF files allowed");
                return;
            }
            group = allDetials.cert_image.split('/');
            filename = group.pop();
            filename = filename.split('.')[0];

        }

        if (allDetials.appType === 'old') {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appType}/${allDetials.mem_no}/cert_image.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress3(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appType}/${allDetials.mem_no}/cert_image.${ext}` });
                    }
                })
            setProgress3(0)

        }
        else {
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `applications/${allDetials.appId}/${filename}.${ext}`
            }

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress3(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)


                    else {
                        setTempDetails({ ...TempDetails, [e.target.name]: `https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/applications/${allDetials.appId}/${filename}.${ext}` });
                    }
                })
            setProgress3(0)
        }
    }
    return (

        <>
            {isVerified ?

                result._id !== undefined &&



                <div style={{ textAlign: 'center', padding: '0 0 50px 0' }}>
                    <h1 >My Details</h1>
                    <div className="applicationContainer">
                        <div className="applicationFields">
                            <table className="applicationTable">
                                <tr>
                                    <td colSpan="2"><b><u>Profile Details</u></b></td>
                                </tr>
                                <tr>
                                    <td>Profile Image</td>
                                    {
                                        Editable ?
                                            <>
                                                <img src={allDetials.profile_image} className="img" style={{ position: 'relative', top: '8px' }} width={125} alt="Profile" />
                                                <input name="profile_image" type="file" onChange={handleFileChange} />
                                                <LinearProgress variant="determinate" value={Progress1} />
                                                <p className="update">{profileE}</p>
                                            </>
                                            :
                                            <>
                                                <td style={{ height: '149px' }}>
                                                    <img src={allDetials.profile_image} className="img" width={125} alt="Profile" />
                                                    <a style={{ position: 'relative', right: '95px', top: '8px' }} href={allDetials.profile_image} target="_blank" rel="noreferrer">Click Here to Download</a>
                                                </td>
                                            </>
                                    }

                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Doctor Details</u></b></td>
                                </tr>
                                <tr>
                                    <td>Doctor Name</td>
                                    <td>{allDetials.name}</td>
                                </tr>
                                <tr>
                                    <td>Membership No</td>
                                    <td>{allDetials.mem_no}</td>
                                </tr>
                                <tr>
                                    <td>Date of Birth (dd/mm/yyyy)</td>
                                    {
                                        Editable ?
                                            <input name="dob" value={TempDetails.dob} onChange={handleChange} type="date" format="dd/MM/yyyy" /> :
                                            <td>{new Date(allDetials.dob).getDate() + '/' + (new Date(allDetials.dob).getMonth() + 1) + '/' + new Date(allDetials.dob).getFullYear()}</td>
                                    }


                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    {
                                        Editable ?
                                            <>
                                                <select name="gender" value={TempDetails.gender} onChange={handleChange}>
                                                    {
                                                        gender.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                {/* <p className="update">{genderE}</p> */}
                                            </> :
                                            <td>{allDetials.gender}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Blood Group</td>
                                    {
                                        Editable ?
                                            <>
                                                <select name="blood_group" value={TempDetails.blood_group} onChange={handleChange}>
                                                    {
                                                        bloodGroup.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                {/* <p className="update">{blood_groupE}</p> */}
                                            </> :
                                            <td>{allDetials.blood_group}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Phone Number</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="phone" value={TempDetails.phone} onChange={handleChange} type="number" />
                                                <p className="update">{phoneE}</p>
                                            </> :
                                            <td>{allDetials.phone}</td>
                                    }
                                </tr>
                                <tr>
                                    <td>Email Address</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="email" value={TempDetails.email} onChange={handleChange} type="email" />
                                                <p className="update">{emailError}</p></> :
                                            <td>{allDetials.email}</td>
                                    }
                                </tr>

                                <tr>
                                    <td>Signature</td>

                                    {
                                        Editable ?
                                            <>
                                                <img src={allDetials.signature_image} className="img" style={{ position: 'relative', top: '8px' }} width={125} alt="Signature" />
                                                <input name="signature_image" type="file" onChange={uplodeSign} />
                                                <LinearProgress variant="determinate" value={Progress2} />
                                                <p className="update">{signatureE}</p>
                                            </>
                                            :
                                            <>
                                                <td style={{ height: '149px' }}>
                                                    <img src={allDetials.signature_image} className="img" width={125} alt="Signature" />
                                                    <a style={{ position: 'relative', right: '95px', top: '8px' }} href={allDetials.signature_image} target="_blank" rel="noreferrer">Click Here to Download</a>
                                                </td>
                                            </>
                                    }


                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Educational Details</u></b></td>
                                </tr>

                                <tr>
                                    <td>Highest Medical Degree</td>

                                    {
                                        Editable ?
                                            <>
                                                {IsDegree ? <input name="qualifications" value={TempDetails.qualifications} onChange={handleChange} /> : <select name="qualifications" value={TempDetails.qualifications} onChange={handleChange}>
                                                    {
                                                        FData.qual.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>}
                                            </>
                                            :
                                            <td>{allDetials.qualifications}</td>

                                    }
                                </tr>
                                <tr>
                                    <td>College</td>
                                    {
                                        Editable ?
                                            <div className="ctrl">
                                                <select name="state" value={SName} onChange={stateChanged}>
                                                    {
                                                        stateList.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                {isTrue ?
                                                    <select name="college" defaultValue={CName} value={CName} onChange={(e) => collegeChanged(e.target.value)}>
                                                        {/* {console.log(collagelist,'colllllllege')} */}
                                                        {collagelist.length > 0 ? collagelist.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        )) : <option value={CName}>{CName}</option>}


                                                    </select> : <input name="college" value={TempDetails.college == "other" ? "" : TempDetails.college} placeholder="Enter Your Collage Name" onChange={handleChange} />
                                                }

                                            </div>
                                            :
                                            <td>{allDetials.college}</td>
                                    }
                                </tr>
                                <tr>
                                    <td>Medical License / College Reg No</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="regno" value={TempDetails.regno} onChange={handleChange} />
                                                <p className="update">{RegE}</p>

                                            </> :

                                            <td>{allDetials.regno}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Medical License / College ID</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="cert_image" type="file" onChange={handleIdChange} />
                                                <LinearProgress variant="determinate" value={Progress3} />
                                                <p className="update">{medError}</p>
                                            </> :
                                            <>
                                                <td style={{ height: '149px' }}>
                                                    <img src={allDetials.cert_image} className="img" width={125} alt="Certificate Image" />
                                                    {/* <td><a href={allDetials.cert_image} target="_blank" rel="noreferrer">Click Here to View</a></td> */}
                                                </td>
                                            </>
                                    }

                                </tr>
                                <tr>
                                    <td><b><u>Correspondence Address</u></b></td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="line1" value={TempDetails.address.line1} onChange={handleAddChange} />
                                                <input name="line2" value={TempDetails.address.line2} onChange={handleAddChange} />
                                                <select name="state" value={TempDetails.address.state} onChange={handleAddChange}>
                                                    {
                                                        FData.states.map((item, index) => (
                                                            <option key={index} value={item.state}>{item.state}</option>
                                                        ))
                                                    }
                                                </select>
                                                <select name="city" value={TempDetails.address.city} onChange={handleAddChange}>
                                                    {
                                                        TempCList.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                <input name="pincode" value={TempDetails.address.pincode} onChange={handleAddChange} />
                                            </td> :
                                            <td>
                                                {address.line1}<br />
                                                {address.line2}<br />
                                                {address.city}, {address.state}<br />
                                                {address.pincode}
                                            </td>
                                    }
                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Association with NMO</u></b></td>
                                </tr>
                                <tr>
                                    <td>NMO State</td>
                                    {
                                        Editable ?
                                            <select name="nmo_state" value={TempDetails.nmo_state} onChange={handelNmoState}>
                                                {
                                                    nmoLists.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{allDetials.nmo_state}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>NMO Prant</td>
                                    {
                                        Editable ?
                                            <select name="prant" value={TempDetails.prant} onChange={handelNmoPrant}>
                                                <option value='none'></option>
                                                {
                                                    nmoPrant.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{allDetials.prant}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>NMO unit</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="nmo_unit" value={TempDetails.nmo_unit} onChange={handleChange} type="text" />
                                            </td> :
                                            <td>{allDetials.nmo_unit}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>NMO State Secretary Email</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="state_sec_email" value={TempDetails.state_sec_email} onChange={handleChange} type="text" />
                                                <p className="update">{secEmailError}</p>
                                            </td> :
                                            <td>{allDetials.state_sec_email}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Referrer/Contact Person  Name</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="ref_person" value={TempDetails.ref_person} onChange={handleChange} type="text" />
                                                <p className="update">{RefnameE}</p>
                                            </td> :
                                            <td>{allDetials.ref_person}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Referrer / Contact Person  Phone Number</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="ref_person_phone" value={TempDetails.ref_person_phone} onChange={handleChange} type="text" />
                                                <p className="update">{secphoneE}</p>
                                            </td> :
                                            <td>{allDetials.ref_person_phone}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Referrer / Contact Person NMO  Membership Number</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="ref_membership_no" value={TempDetails.ref_membership_no} onChange={handleChange} type="text" />
                                                <p className="update">{RefMemN}</p>
                                            </td> :
                                            <td>{allDetials.ref_membership_no}</td>
                                    }

                                </tr>

                                {memDoc ?
                                    <>
                                        <tr>
                                            <td colSpan="2"><b><u>Member Documents</u></b></td>
                                        </tr>
                                        <tr>
                                            <td>Certificate Image</td>
                                            <td>
                                                <a href={allDetials.mem_cert_image} target="_blank" rel="noreferrer">Click Here to View</a></td>
                                        </tr>
                                        <tr>
                                            <td>ID Card Image</td>
                                            <td>
                                                <a href={allDetials.mem_idCard_image} target="_blank" rel="noreferrer">Click Here to View</a></td>
                                        </tr>

                                    </> :
                                    <tr></tr>}
                                <tr>
                                    <td>
                                        <Button variant="contained" color={Editable ? "secondary" : 'primary'} onClick={handleEdit}>{Editable ? "Cancel" : "Edit"}</Button>
                                    </td>
                                    <td>
                                        {Editable && <Button variant="contained" color='primary' onClick={handleUpdate}>Update</Button>}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                : <h1>{updatemsg}</h1>}
            <Dialog open={IsOpen7} >
                <DialogTitle >{"Update Data?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Update your Data?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlefinalUpdate} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNoApp} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MemberApplicationsView
